import { useMutation } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { DCSQueryClient } from "../../../queryClient";
import { SectionHeader } from "../../../components/SectionHeader/SectionHeader";
import { useToast } from "../../../Providers/ToastProvider";
import { requests } from "../../../services/http-common";
import { EmployeeForm } from "../EmployeeForm/EmployeeForm";
import { useKeycloakContext } from "../../../keycloak";

type EmployeeEditProps = {
  isOwn?: boolean;
};

export const EmployeeEdit = ({ isOwn }: EmployeeEditProps) => {
  let { employeeId } = useParams<{ employeeId: string }>();

  const keycloakContexxt = useKeycloakContext();
  const subId = keycloakContexxt.keycloak?.tokenParsed?.sub;

  if (isOwn) {
    employeeId = subId;
  }

  const navigate = useNavigate();
  const { show } = useToast();

  const updateEmployee = useMutation({
    mutationFn: (newLead: any) => {
      return requests.put(`/user/${employeeId}`, newLead);
    },
    onSuccess: () => {
      show({ detail: "Employee was updated successfully !" });
      // navigate("/management/employees");
      navigate('/profile')
      DCSQueryClient.invalidateQueries({ queryKey: ["employee-list"] });
    },
    onError: (error: any) => {
      show({
        severity: "error",
        detail: error.response?.data?.error?.message || "Something went wrong ",
      });
    },
  });

  return (
    <>
      <SectionHeader
        showBackButton={isOwn}
        title={isOwn ? "Edit Profile" : "Edit employee"}
      />
      <EmployeeForm
        onSubmit={updateEmployee.mutate}
        employeeId={employeeId}
        isPending={updateEmployee.isLoading}
      />
    </>
  );
};
